export default __webpack_public_path__ + "static/media/36I-102702_-15679_0.485244d1.jpg";